import request from '@/utils/request'

// 인기검새어 조회
export function getSearchWordList (data) {
  return request({
    url: '/main/searchWordList',
    method: 'post',
    data
  })
}


// 검색 결과 조회
export function getSearchGoodsList (data) {
  return request({
    url: '/main/searchGGoods',
    method: 'post',
    data
  })
}

// 마케팅 검색어 조회
export function getMarketingWord (data) {
  return request({
    url: '/main/searchMarketingWordList',
    method: 'post',
    data
  })
}

// 마케팅 검색어로 상품 검색 
export function getMarketingGoodsList (data) {
  return request({
    url: '/main/searchMarketingGGoods',
    method: 'post',
    data
  })
}
